// Get saved filters
import { ISavedFiltersSearchCandidateRequestModel, ISavedFiltersSearchCandidateResponseModel } from "./_models"
import axios from "axios"
import { CONST_API_PERSONNEL_SAVED_FILTERS_AND_LOGS_SEARCH_CANDIDAT_GET_SAVED_FILTERS_ENDPOINT } from "../../../../../../../endpoints"

export function getSavedFiltersSearchCandidate(filters: ISavedFiltersSearchCandidateRequestModel) {
     return axios.post<ISavedFiltersSearchCandidateResponseModel>(CONST_API_PERSONNEL_SAVED_FILTERS_AND_LOGS_SEARCH_CANDIDAT_GET_SAVED_FILTERS_ENDPOINT, filters)
}
